import { useState, useReducer } from 'react';

const useEntityData = () => {
  const [entityData, setEntityData] = useState({});
  const [entityToEdit, setEntityToEdit] = useState({});
  const [entityId, setEntityId] = useState(null);
  const [entityCompositeKey, setEntityCompositeKey] = useState(undefined);
  const [idsToClear, dispatchIdsState] = useReducer(
    (prevState, payload) => ({ ...prevState, ...payload }),
    { toggleState: 1, ids: {} }
  );

  return {
    entityData,
    setEntityData,
    entityToEdit,
    setEntityToEdit,
    entityId,
    setEntityId,
    entityCompositeKey,
    setEntityCompositeKey,
    idsToClear,
    dispatchIdsState,
  };
};

export default useEntityData;
